import type { TExposedPersonDTO } from '@doutorsim/shared/persons'
import type { ColumnDef } from '@tanstack/react-table'
import { Link } from '@tanstack/react-router'

export type TGuarantorColumns = Pick<TExposedPersonDTO, 'id' | 'name' | 'email' | 'phone'> & {
  applicationId: string
  companySlug: string
  facilitySlug: string
}

function getGuarantorLink(row: { original: TGuarantorColumns }) {
  const { companySlug, facilitySlug, applicationId, id } = row.original
  return `/companies/${companySlug}/facilities/${facilitySlug}/applications/${applicationId}/guarantors/${id}/profile` as any
}

export const guarantorColumns: ColumnDef<TGuarantorColumns>[] = [
  {
    accessorKey: 'name',
    header: 'Nome',
    cell: ({ row }) => (
      <Link to={getGuarantorLink(row)} className="inline-flex w-full px-8 py-3">
        <span>{row.original.name}</span>
      </Link>
    ),
  },
  {
    accessorKey: 'email',
    header: 'Email',
    cell: ({ row }) => (
      <Link to={getGuarantorLink(row)} className="inline-flex w-full px-8 py-3">
        <span>{row.original.email}</span>
      </Link>
    ),
  },
  {
    accessorKey: 'phone',
    header: 'Telefone',
    cell: ({ row }) => (
      <Link to={getGuarantorLink(row)} className="inline-flex w-full px-8 py-3">
        <span>{row.original.phone}</span>
      </Link>
    ),
  },
]
